import React, { useState } from 'react';
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Textarea,
    Alert,
    Text,
} from '@chakra-ui/react';
import * as Sentry from '@sentry/browser';

const defaultFormState = {
    name: '',
    email: '',
    comments: '',
};

const FeedbackForm = (props) => {
    const [formData, setFormData] = useState(defaultFormState);
    const [displayError, setDisplayError] = useState(false);
    const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);

    // TODO: might be worth using React Hook Form/Formik/other form library to handle validation etc...
    const validateForm = () => {
        if (formData.name.length < 1 || formData.email.length < 1 || formData.comments.length < 1 ) {
            setDisplayError(true);
            return false;
        } 

        return true;
    };

    const onChange = (e) => {
        setDisplayError(false);
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const now = new Date();

        if (!validateForm()) {
            return null;
        }

        const eventId = Sentry.captureMessage(`User Feedback ${now.toString()}`);
        const userFeedback = {
            ...formData,
            event_id: eventId,
        };

        Sentry.captureUserFeedback(userFeedback);
        // ^not sure of a way to see whether this was successful/finished etc
        // in a Sentry (React Native) example they just assume clear the form and carry on, so we'll do that for now
        // https://github.com/getsentry/sentry-react-native/blob/4bc2c4362d1c676e8f8967b2544cf3a0e9bc663b/sample/src/components/UserFeedbackModal.tsx#L52
        // If needed, we can handle the POST request ourselves with this approach: https://docs.sentry.io/api/projects/submit-user-feedback/

        setFormData(defaultFormState);
        setFeedbackSubmitted(true);
    };

    if (feedbackSubmitted) {
        return (
            <Text>Thank you for your feedback!</Text>
        );
    }

    return (
        <form onSubmit={onSubmit}>
            <FormControl mt={2} isRequired>
                <FormLabel>Name</FormLabel>
                <Input type='text' name='name' onChange={onChange} value={formData.name} />
            </FormControl>

            <FormControl isRequired mt={2}>
                <FormLabel>Email address</FormLabel>
                <Input type='email' name='email' onChange={onChange} value={formData.email} />
            </FormControl>
            <FormControl isRequired mt={2}>
                <FormLabel>Comments</FormLabel>
                <Textarea name='comments' onChange={onChange} value={formData.comments}></Textarea>
            </FormControl>
            {displayError && 
                <Alert status='warning' mt={2} mb={2}>Please complete required fields.</Alert>
            }
            <Button colorScheme='teal' mt={3} mb={3} type='submit' onClick={onSubmit}>Send Feedback</Button>
        </form>
    );
};

export default FeedbackForm;
